//
// Generated class ChangelogAppSync
//

/// <reference path="ChangelogAppSync_ManagedObject.ts" />

class ChangelogAppSync extends ChangelogAppSync_ManagedObject
{

}
